import { useEffect, useState } from "react";

import { FormattedMessage } from "react-intl";
import userService from "../services/user-service";
import PostComponent from "./Posts/Posts";

const Home: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState("Loading...");

  useEffect(() => {
    setLoading(true);
    userService
      .getPublicContent()
      .then((response) => {
        setContent(response.data);
        setLoading(false);
      })
      .catch((error) => {
        const content =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();

        setContent(content);
      });
  }, []);

  return (
    <div className="container">
      {loading && <p>{content}</p>}
      <header className="jumbotron">
        <h3>
          <FormattedMessage id="welcome" />
        </h3>
      </header>
      <PostComponent
        isPublic={true}
        canDelete={false}
        showCreateButton={false}
      />
    </div>
  );
};

export default Home;
